import { putRequest } from "../../../api/http";
import { message } from "antd";

const reArrangeOrder = async (apiUrl, payload) => {
  const response = await putRequest(apiUrl, payload);
  if (response?.length) {
    message.success("Re-arranged successfully");
  }
  return response;
};

export default reArrangeOrder;
